var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0536 7.14221C13.186 8.19922 12.9848 9.27117 12.4782 10.2083C11.9717 11.1454 11.185 11.9008 10.2281 12.3689C9.2712 12.8371 8.19197 12.9946 7.1412 12.8194C6.09044 12.6443 5.12065 12.1452 4.36737 11.392",
    stroke: "#6576FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90339 8.35997C2.82162 7.64435 2.89197 6.91952 3.10984 6.23298C3.32771 5.54645 3.68818 4.91369 4.16762 4.37616C4.64707 3.83864 5.23468 3.40848 5.89196 3.11388C6.54923 2.81927 7.26134 2.66686 7.98162 2.66663C8.65281 2.66574 9.31757 2.79744 9.93773 3.05417C10.5579 3.31089 11.1212 3.68759 11.5954 4.16263",
    stroke: "#6576FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.33334 6.22217L2.90335 8.35973L4.8889 6.66661",
    stroke: "#6576FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 9.33333L13.0535 7.14221L11.111 8.88888",
    stroke: "#6576FF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.979d7660.svg";
export { ForwardRef as ReactComponent };